import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import { Button } from '@/common/ui/button'
import useMutationDeleteCommission from '@/modules/promotion/api/hooks/useMutateDeleteCommission'
import { CommissionCashbackQueryKeys } from '@/modules/promotion/keys'
import { useQueryClient } from '@tanstack/react-query'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'

interface DeleteCommissionProps {
	id: string
}

export const DeleteCommission = ({ id }: DeleteCommissionProps) => {
	const queryClient = useQueryClient()
	const { mutate: deleteCommission } = useMutationDeleteCommission({
		onSuccess: () => {
			toast.success('ลบค่าคอมมิชชั่นสำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [CommissionCashbackQueryKeys.GetCommissionCashbackList],
			})
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleDelete = () => {
		deleteCommission({ id })
	}

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="h-4 w-4 text-destructive" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ยืนยันการลบค่าคอมมิชชั่น</AlertDialogTitle>
					<AlertDialogDescription>
						การกระทำนี้ไม่สามารถย้อนกลับได้
						คอมมิชชั่นนี้จะถูกลบออกจากระบบอย่างถาวร
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction onClick={handleDelete}>ลบ</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
